<template>
  <section class="comp-footer bt-3">
    <footer class="tc" :class="[isSample ? 'pt10 pb10' : 'pt20 pb20']">
      <p class="text-color-3 mb15" v-if="!isSample">
        <router-link tag="a" target="_blank" class="mr5" :to="{name: 'HelpAbout'}">关于我们</router-link> |
        <router-link tag="a" target="_blank" class="mr5 ml5" :to="{name: 'HelpSecret'}">隐私条款</router-link> |
        <!--<router-link tag="a" class="mr5 ml5" to="/">人才招聘</router-link> |-->
<!--        <router-link tag="a" target="_blank" class="mr5 ml5" :to="{name: 'HelpMessage'}">留言反馈</router-link> |-->
        <router-link tag="a" target="_blank" class="mr5 ml5" :to="{name: 'HelpFriendLink'}">教育网址导航</router-link> |
        <router-link tag="a" target="_blank" class="ml5" :to="{name: 'HelpContact'}">联系我们</router-link>
      </p>
      <p class="text-color-4 f13">© 2019 河南天星教育科技有限公司 All rights reserved</p>
      <p class="text-color-4 f13 pt10 zizhi" v-if="!isSample">

        <!--      <a href="http://www.miitbeian.gov.cn/" target="_blank">豫ICP备18005306号</a>-->
        <!--      <a href="http://www.miitbeian.gov.cn/" target="_blank">增值电信业务经营许可证（豫）B2-20160357</a>-->
        <!--      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41019702002013" target="_blank">豫公网安备 41019702002013号</a>-->
        <a class="mr5" href="http://beian.miit.gov.cn/" target="_blank">豫ICP备18005306号-4</a>
        <a href="https://tsm.miit.gov.cn/FineReport/base/publicField/%E8%B1%ABB2-20160357/" target="_blank">增值电信业务经营许可证（豫）B2-20160357</a>
        <img src="../assets/icon/anbei.png" alt="" class="ml5" style="vertical-align: -3px;margin-right: 3px;height:15px;">
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41019702002013" target="_blank">豫公网安备 41019702002013号</a>
      </p>
    </footer>
  </section>
</template>

<script>
  /**
   * @author yueheqin
   * @date 2018/12/17
   * @project kaoshizhongxin-pc
   * @desc
   */
  export default {
    name: 'comp-footer',
    props: {
      isSample: Boolean
    },
    data () {
      return {}
    }
  }
</script>

<style lang="less">
  @import "../styles/_mixins-wln";
  .comp-footer {
    background: @body-footer;
    footer{
      width: @body-min-width;
      margin: 0 auto;
      .zizhi a:hover{
        color: @primary;
        text-decoration: underline;
      }
    }
  }
</style>
